// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MOST_CREATIVE_PEOPLE_PAGE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeoplePage: action.mostCreativePeoplePage
      };
    },
    MOST_CREATIVE_PEOPLE_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.homepage
      };
    },
    MOST_CREATIVE_PEOPLE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeoplePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
